import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '@/context/AuthContext';
import { API } from '@/config/api';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setAuthData } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          toast.error('Authentication failed: No session found');
          navigate('/login', { replace: true });
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for user data via backend
        const response = await axios.post(`${API}/auth/google/callback`, {
          session_id: sessionId
        });

        const { token: access_token, user } = response.data;

        // Store token and update auth context
        localStorage.setItem('token', access_token);
        if (setAuthData) {
          setAuthData(access_token, user);
        }

        toast.success(`Welcome, ${user.name}!`);
        
        // Redirect to dashboard or setup based on hotel_id
        if (user.hotel_id) {
          navigate('/', { replace: true });
        } else {
          navigate('/setup', { replace: true });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        const errMsg = error.response?.data?.detail || 'Authentication failed';
        toast.error(errMsg);
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [navigate, setAuthData]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
